import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [hasCheckedAuth, setHasCheckedAuth] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  // Fetch user profile from backend
  const refreshUser = async () => {
    try {
      const response = await axios.get(`${apiUrl}/account/profile`, {
        withCredentials: true, // important for cookies
      });
      setUser(response.data);
    } catch (error) {
      setUser(null);
    } finally {
      setHasCheckedAuth(true);
    }
  };

  // On mount, check auth
  useEffect(() => {
    refreshUser();
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, hasCheckedAuth, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};